/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Card, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

/* ------------------------------------- DEPENDENCIES -------------------------------------- */
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

AddNewCardForm.propTypes = {
  handleChangeSelectedCard: PropTypes.func
};
export default function AddNewCardForm({ handleChangeSelectedCard }) {
  const t = useTranslation();
  const elements = useElements();
  const stripe = useStripe();
  const session = useSelector(selectSession);
  const [isSubmitting, setSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function handleSubmit(values) {
    setSubmitting(true);
    const cardElement = elements.getElement(CardElement);
    stripe
      .createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: values.fullName,
          email: session.email,
          phone: session.phone === '' ? null : session.phone
        }
      })
      .then((result) => {
        if (result.error) {
          switch (result.error.code) {
            case 'incomplete_number':
              enqueueSnackbar(t('ANC_IncompleteNumber'), { variant: 'error' });
              break;
            case 'incomplete_expiry':
              enqueueSnackbar(t('ANC_IncompleteExpiry'), { variant: 'error' });
              break;
            case 'incomplete_cvc':
              enqueueSnackbar(t('ANC_IncompleteCvc'), { variant: 'error' });
              break;
            case 'incomplete_zip':
              enqueueSnackbar(t('ANC_IncompleteZip'), { variant: 'error' });
              break;
            case 'invalid_number':
              enqueueSnackbar(t('ANC_InvalidNumber'), { variant: 'error' });
              break;
            default:
              enqueueSnackbar(t('ANC_DefaultError'), { variant: 'error' });
              break;
          }
        } else {
          handleChangeSelectedCard(result.paymentMethod);
        }
      });
    setSubmitting(false);
  }

  return (
    <Card>
      <Stack spacing={2} padding={2}>
        <CardElement hidePostalCode="true" />
        <LoadingButton
          fullWidth
          type="submit"
          variant="contained"
          loading={isSubmitting}
          onClick={(values) => handleSubmit(values)}
        >
          <Typography variant="button">{t('btn_Add')}</Typography>
        </LoadingButton>
      </Stack>
    </Card>
  );
}
